import React, { useRef } from "react";
// import { Badge } from "react-bootstrap";

// import "./Print.css"
import logo from "../../../Assets/Images/cebu-south.png"

export class PrintMedicalAbstract extends React.PureComponent{

    render() {
        // const marginTop="0px"
        // const marginRight="0px"
        // const marginBottom="0px"
        // const marginLeft="0px"
        // const getPageMargins = () => {
        //     return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
        // };

        return (
            <div className="container">
                {/* <style>{getPageMargins()}</style> */}
                <div className="print-area dotted rounded p-5">
                    <div className="d-flex row justify-content-center" >
                        <div className="col-sm-1">
                            <img src={logo} height={50} width={100} alt="logo"/>
                        </div>
                        <div className="col-sm-10 text-center">
                            <div className="row">
                                <label><h3><strong>Vanessa G. Ibale,{" "}M.D.,{" "}FPCP,{" "},FPSN</strong></h3></label>
                            </div>
                            <div className="row">
                                <label><>Internal Medicine - Disease of Kidney, Hypertension, Dialysis, and Transplantation</></label>
                            </div>
                            <div className="row">
                                <label><>Fellow, Philippine College of Physicians</></label>
                            </div>
                            <div className="row">
                                <label><>Fellow, Philippine Society of Nephrology</></label>
                            </div>
                        </div>
                        <div className="col-sm-1">
                            <img src={logo} height={50} width={100} alt="logo"/>
                        </div>
                    </div> 
                    <div className="row pt-5 d-flex justify-content-center text-center" >
                        <label><h3><strong>Medical Abstract</strong></h3></label>
                    </div> 
                    <div className="row pt-5 d-flex justify-content-center text-right" >
                        <div className="row">
                            <label><span>August</span>{" "}18,{" "}<span>2023</span></label>
                        </div>
                    </div>
                    <div className="row pt-4 d-flex justify-content-center text-left" >
                        <div className="row">
                            <div className="col">
                                <label><span>This is a case of</span><strong>{" "}Sample Name{" "}</strong>,<span>{" "}19/M,.</span></label>
                            </div>
                        </div>
                    </div>
                    <div className="row pt-5 d-flex justify-content-center text-left" >
                        <div className="row">
                            <label><h5><strong>DIAGNOSIS</strong></h5></label>
                        </div>
                        <div className="row">
                            <label>*</label>
                        </div>
                    </div>
                    <div className="row pt-5 d-flex justify-content-center text-left" >
                        <div className="row">
                            <label><h5><strong>THERAPUETICS</strong></h5></label>
                        </div>
                        <div className="row">
                            <label>1.</label>
                        </div>
                    </div>
                    <div className="row pt-5 d-flex justify-content-center text-left" >
                        <div className="row">
                            <label><h5><strong>PLAN</strong></h5></label>
                        </div>
                        <div className="row">
                            <label>........</label>
                        </div>
                    </div>
                </div>               
            </div>
        );
    }
}

export default PrintMedicalAbstract;